// Module
var code = `<condition ng-if="\$ctrl.propertyDefinition.type === \$ctrl.type"
           conditions="\$ctrl.conditions"
           property="\$ctrl.propertyDefinition.property">
  <div class="condition-container">
    {{\$ctrl.propertyDefinition.label}}

    <select ng-model="\$ctrl.model.param"
            required
            ng-change="\$ctrl.valueChanged()"
            boolean-options>
    </select>
  </div>
</condition>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/risk-profiling/conditions/boolean-condition.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;